<template>
  <div class="card my-4 mx-4">
    <div class="card-header pb-0">
      <h6>Edit Terms & Conditions CMS</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="p-3">
        <Form
          as="form"
          class="form"
          @submit="onSubmit"
          :initial-values="initialData"
          :validation-schema="schema"
          v-slot="{ errors }"
          v-if="termsConditionObj"
        >
          <div class="form-group row">
            <div class="col-md-5">
              <label for="title">Title</label>
              <Field
                name="title"
                type="text"
                class="form-control"
                v-model="termsConditionObj.title"
                :class="{ 'is-invalid': errors.title }"
              />
              <div class="invalid-feedback">{{ errors.title }}</div>
            </div>
            <div class="col-md-5">
              <label for="title">Arabic Title</label>
              <Field
                name="title_ar"
                type="text"
                class="form-control"
                v-model="termsConditionObj.title_ar"
                :class="{ 'is-invalid': errors.title_ar }"
              />
              <div class="invalid-feedback">{{ errors.title_ar }}</div>
            </div>
          </div>
          <div class="form-group my-2">
            <label for="exampleInputEmail1">Description</label>
            <quill-editor
              v-model:content="termsConditionObj.description"
              class="mb-3"
              id="rich-text"
              rows="20"
              ref="quill"
              @change="onChange($event)"
            >
            </quill-editor>
          </div>
          <div class="form-group my-2">
            <label for="exampleInputEmail1">Arabic Description</label>
            <quill-editor
              v-model:content="termsConditionObj.description_ar"
              class="mb-3"
              id="rich-text"
              rows="20"
              ref="quill"
              @change="onChangeAR($event)"
            >
            </quill-editor>
          </div>
          <div class="my-4">
            <div class="form-group row">
              <h4>Meta Data</h4>
              <div class="col-md-6">
                <label for="">Meta Title</label>
                <Field
                  name="meta_title"
                  type="text"
                  as="input"
                  class="form-control"
                  v-model="termsConditionObj.meta_title"
                  :class="{ 'is-invalid': errors.meta_title }"
                />
                <div class="invalid-feedback">
                  {{ errors.meta_title }}
                </div>
              </div>
              <div class="col-md-6">
                <label for="">Meta Description</label>
                <Field
                  name="meta_description"
                  type="text"
                  as="textarea"
                  class="form-control"
                  v-model="termsConditionObj.meta_description"
                  :class="{ 'is-invalid': errors.meta_description }"
                />
                <div class="invalid-feedback">
                  {{ errors.meta_description }}
                </div>
              </div>
              <div class="col-md-6">
                <label for="">Meta Keywords</label>
                <Field
                  name="meta_keywords"
                  type="text"
                  as="textarea"
                  class="form-control"
                  v-model="termsConditionObj.meta_keywords"
                  :class="{ 'is-invalid': errors.meta_keywords }"
                />
                <div class="invalid-feedback">
                  {{ errors.meta_keywords }}
                </div>
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-danger my-2">Submit</button>
          <button
            type="button"
            @click="handleCancel"
            class="btn btn-outline-success my-2 cancel-btn"
          >
            Cancel
          </button>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, Form, useForm } from "vee-validate";
import * as yup from "yup";
import { mapGetters } from "vuex";
import _ from "lodash";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
export default {
  name: "Terms And Conditions",
  components: {
    Field,
    Form,
    quillEditor,
  },
  data() {
    const { setFieldValue } = useForm();
    const schema = yup.object().shape({
      title: yup.string().trim().required("Title is Required"),
      title_ar: yup.string().trim().required("Arabic Title is Required"),
      meta_title: yup.string().trim(),
      meta_description: yup.string().trim(),
      meta_keywords: yup.string().trim(),
    });

    const initialData = {
      title: "",
      title_ar: "",
      meta_title: "",
      meta_description: "",
      meta_keywords: "",
    };

    return {
      description: "",
      description_ar: "",
      meta_title: "",
      meta_description: "",
      meta_keywords: "",
      schema,
      initialData,
      setFieldValue,
    };
  },
  computed: {
    ...mapGetters("termsConditions", ["termsConditionObj", "isLoading"]),
  },
  async mounted() {
    await this.fetchDetail();
    let initData = this.termsConditionObj
      ? _.clone(this.termsConditionObj)
      : {};

    this.initialData = this.termsConditionObj
      ? {
          ...initData,
        }
      : this.initialData;

    this.description = this.termsConditionObj.description;
    this.description_ar = this.termsConditionObj.description_ar;
    this.meta_title = this.termsConditionObj.meta_title;
    this.meta_description = this.termsConditionObj.meta_description;
    this.meta_keywords = this.termsConditionObj.meta_keywords;
  },
  methods: {
    onChange(event) {
      this.description = event.html;
    },
    onChangeAR(event) {
      this.description_ar = event.html;
    },
    async fetchDetail() {
      try {
        await this.$store.dispatch(
          "termsConditions/fetchTermsConditionsDetail",
          1
        );
      } catch (err) {
        console.log(err);
      }
    },
    onSubmit(values) {
      const obj = {
        ...values,
        description: this.description,
        description_ar: this.description_ar,
        meta_title: this.termsConditionObj.meta_title,
        meta_description: this.termsConditionObj.meta_description,
        meta_keywords: this.termsConditionObj.meta_keywords,
      };
      this.$store.dispatch("termsConditions/put", obj)
        .then(() => {
          this.$swal({
            position: "center",
            icon: "success",
            title: "Terms And Conditions Page has been Updated",
            showConfirmButton: false,
            timer: 2000,
          });
          this.$router.push("/cms");
        })
        .catch(err => {
          console.error("Update failed:", err);
        });
    },
    handleCancel() {
      this.$router.push("/cms");
    },
  },
};
</script>
